<template>
  <div class="content">
    <div class="container">
      <div class="holder holder-image">
        <div id="js-imageBuildeContainer" class ref="canvasWrapper">
          <div id="span-order-numder" class="order-numder">
            <span style>{{ $t('front_end.a025.order_number_label') }}{{ordererInformation.orderNo}}</span>
          </div>
        </div>
        <div class="mt-4" v-if="postcardInfomation.imageURL">
          <img :src="postcardInfomation.imageURL" alt="preview Image" />
        </div>
      </div>
      <!-- <p>test</p> -->
      <!-- <button @click="goback">back</button> -->
      <div id="message-confirm" class="message-confirm mt-3">
        <span>{{$t('front_end.a025.message_confirm')}}</span>
      </div>
      <div class="content-footer-detail-design container" id="content-footer-detail">
        <button
          :class="fixingDesign ?   'btn-editor-edit' : 'btn-editor-submit'"
          class="col-md-2 col-4 offset-col-1 btn-editor"
          :disabled="fixingDesign"
          @click.prevent="pushToEditDesign"
        >{{$t('front_end.a025.btn_edit')}}</button>
        <button
          :class="publicTemplate ? 'btn-editor-submit' : 'btn-editor-edit'"
          class="col-md-2 col-4 offset-1 offset-md-1 btn-editor-submit btn-editor"
          :disabled="!publicTemplate"
          @click="pushToConfirmPrint"
        >{{$t('front_end.a025.btn_submit')}}</button>
      </div>
    </div>
  </div>
</template>
<script>
// import api from "@/services/api";
// import apiEndpoints from "@/services/apiEndpoints";
import { mapGetters, mapState } from "vuex";
import apiEndpoints from "@/services/apiEndpoints";
import api from "@/services/api";

const FROMA025 = "a025";
export default {
  name: "A025",
  data() {
    return {
      postcardInfomation: {
        name: "",
        imageURL: ""
      },
      ordererInformation: {
        orderNo: ""
      }
    };
  },
  created() {
    //TODO khi khach kh lam xong a020
    // this.makeDummy();
    this.init();
  },
  computed: {
    ...mapState({
      templateActive: state => state.userData.templates.templateActive ?? {}
    }),
    ...mapGetters(["shopMode", "userData"]),
    statusTemplate() {
      return this.userData.selected?.template?.templateStatus;
    },

    /*
      return true neu da thuc hien [デザイン再編集/ edit lại design] ở màn hinh a060
    */
    fixingDesign() {
      return !!this.userData.selected?.confirm_edited;
    },
    publicTemplate() {
      return this.statusTemplate == this.$t("front_end.a025.public_template")
        ? true
        : false;
    }
  },
  methods: {
    makeDummy() {
      this.postcardInfomation.imageURL = "https://i.imgur.com/XLugQLn.jpg";

      this.ordererInformation.orderNo = "orderNo-001";
    },

    init() {
      this.ordererInformation.orderNo = this.userData?.order?.orderNo;

      this.getImagePreview();
    },
    async getImagePreview() {
      //CR :1pfwb8sZ
      // this.ordererInformation.orderNo = "020081301000125";
      let respPG = await api.post(apiEndpoints.productGenerate, {
        orderno: this.ordererInformation.orderNo
      });

      if (respPG && respPG.data?.code && Number(respPG.data.code) === 200) {
        let respEdu = await api.post(apiEndpoints.editDataUploadUrl, {
          orderNo: this.ordererInformation.orderNo,
          filename: "preview-image-" + this.ordererInformation.orderNo,
          accessType: "preview"
        });

        // console.log("respEdu", respEdu);
        if (respEdu && respEdu.data?.url) {
          this.postcardInfomation.imageURL = respEdu.data.url;
          this.$store.commit("userData/SET_ORDER", {
            thumbnailBackURL: respEdu.data.url
          });
        }
      }
    },
    pushToEditDesign() {
      if (this.fixingDesign) {
        return;
      }

      location.href =
        "/editor/" + this.templateActive.templateId + "?from=" + FROMA025;
    },

    goback() {
      location.href =
        "/editor/" + this.templateActive.templateId + "?from=" + FROMA025;
    },
    pushToConfirmPrint() {
      if (!this.publicTemplate) {
        return;
      }
      if (this.fixingDesign) {
        this.$router.push({ name: "a060" });
      } else {
        this.$router.push({ name: "a030" });
      }
    }
  }
};
</script>

<style scoped src="../../assets/css/detailDesign/detailDesign.css"></style>
<style scoped src="../../assets/css/editor/editor.css"></style>

<style scoped>
.holder-image {
  width: 60%;
}
.order-numder {
  margin-top: 1.5rem !important;
}
</style>
